export const PRODUCT_IMAGES_URL_PREFIX = "productImages/"
export const WINDOW_WIDTH_CHANGE_TO_MOBILE_NAVBAR = 700
export const WINDOW_WIDTH_CHANGE_TO_MOBILE_ITEM_DETAIL = 700